import { useQuery } from "@tanstack/react-query";

import { api } from "@/api";
import { queryKeys } from "@/api/queryKeys";
import { useRealtime } from "@/realtime/RealtimeProvider";

export const BALANCE_POLLING_FALLBACK_MS = 20_000;

export function useWalletBalance(playerId: number | null | undefined) {
  const { mode } = useRealtime();

  return useQuery({
    queryKey: queryKeys.balance(playerId),
    queryFn: api.balance,
    enabled: Boolean(playerId),
    retry: 1,
    refetchInterval: mode === "live" ? false : BALANCE_POLLING_FALLBACK_MS,
    refetchOnWindowFocus: true,
  });
}
